<template>
    <div class="additional-document-main">

        <div class="notification is-white">

            <div class="level has-text-centered">
<!--                <div class="level-item">-->
<!--                    <button class = "document-button button is-small" @click="GetResultOfWeatherWeb(-1)"-->
<!--                            :title = WeatherWebButtonTitle-->
<!--                            :class = "{'is-info':selectedDocumentId ===-1}">{{WeatherWebButtonTitle | formatStringLenght}}-->
<!--                    </button>-->
<!--                </div>-->
                <div class="level-item">
                    <button class = "document-button button is-small" @click="GetResultOfNotamWeb(-2)"
                            :title = NotamWebButtonTitle
                            :class = "{'is-info':selectedDocumentId ===-2}">{{NotamWebButtonTitle | formatStringLenght}}
                    </button>
                </div>
<!--                <div class="level-item">-->
<!--                    <button class = "document-button button is-small" @click="GetResultOfNotamPdf(-3)"-->
<!--                            :title = NotamPdfButtonTitle-->
<!--                            :class ="{'is-info':selectedDocumentId ===-3}">{{NotamPdfButtonTitle | formatStringLenght}}-->
<!--                    </button>-->
<!--                </div>-->
                <div class="level-item">
                    <button class = "document-button button is-small" @click="GetResultOfRaimPredictionRawHtml(-4)"
                            :title = RaimPredictionButtonTitle
                            :class = "{'is-info':selectedDocumentId ===-4}">{{RaimPredictionButtonTitle | formatStringLenght}}
                    </button>
                </div>
<!--                <div class="level-item">-->
<!--                    <button class = "document-button button is-small" @click="GetResultOfMeteo(-5)"-->
<!--                            :title = MeteoButtonTitle-->
<!--                            :class ="{'is-info':selectedDocumentId ===-5}">{{MeteoButtonTitle | formatStringLenght}}-->
<!--                    </button>-->
<!--                </div>-->
                <div class="level-item">
                    <button class = "document-button button is-small" @click="GetResultOfFIRNotam(-6)"
                            :title = FIRNotamButtonTitle
                            :class ="{'is-info':selectedDocumentId ===-6}">{{FIRNotamButtonTitle | formatStringLenght}}
                    </button>
                </div>
            </div>

            <div class="level has-text-centered">
                <div v-for="attachment in AttachmentsJson" :key="attachment.AttachmentId" class="level-item">
                    <button class = "document-button button is-small"
                            :title = "attachment.RealName" @click="GetResultOfOutput(flight.fKeyForZip,flight.std,attachment.id,attachment.alvt,attachment.attachmentTypeId)">
                            {{attachment.realName.substring(0,10)+".."}}
                    </button>
                </div>
            </div>

        </div>

        <div class="content" :class = "{hide : !Pdfshow}">

        <embed type="application/pdf"
               :src="getPdfStreamUrl"
               width="100%" height="100%" alt="pdf"
               background-color="0xFF525659" top-toolbar-height="56" full-frame=""
               internalinstanceid="21"
               title="CHROME">
        </div>

        <div class="content" :class="{hide : !Datashow}">
            <div v-for="post in NotamWebObj" :key="post.idx">
                <div v-for="p in post.NotamInfoList" :key="p.idx">
                    <pre v-html="getValueWithImportantWord(p.NotamInfo)"></pre>
<!--                    <pre>{{p.NotamInfo}}</pre>-->
                </div>
            </div>
        </div>

        <div class="content" style="font-family: Consolas" :class="{hide : !NotamShow}">
            <div v-for="notam in NotamObj" :key="notam.SequenceId">
                <p>  {{notam.Subject1}} {{notam.Subject2}}  </p>
                <p>  {{notam.AirportICAO}} {{notam.Source}} SVT:{{notam.StartValidTime}} / EVT:{{notam.EndValidTime}} {{notam.KeyForSubject}} ALT Lower Feet:{{notam.AltitudesLowerFeet}} / ALT Upper Feet:{{notam.AltitudesUpperFeet}} </p>
                <p>  {{notam.Text}}  </p>
                <hr>
            </div>
        </div>

        <div class="content" :class="{hide : !Weatherwebshow}">
            <div v-for="post in WeatherWebObj" :key="post.idx">
                    <pre v-if="post.WeatherText != null">{{post.WeatherText}}</pre>
                    <div v-else-if="post.WeatherText == null">
                        <pre> <span style="color: red">{{post.AirportIcao}} : weather data not found. </span> </pre>
                    </div>
            </div>
        </div>


        <div class="content" :class="{hide : !FIRNotamShow}">

            <pre v-html="getValueWithImportantWord(FIRNotamObj)"></pre>

        </div>

        <div class="content" :class="{hide : !Meteoshow}">
            <br/>
            <div v-if="MeteoObj != null && MeteoObj != '' ">
                <div>
                        <p>DEP : {{MeteoObj.Dep.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.Dep.MetarText}}</p><br/>
                        <p>{{MeteoObj.Dep.TafText}}</p>
                    <hr>
                </div>
                <div>
                        <p>ARR : {{MeteoObj.Arr.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.Arr.MetarText}}</p><br/>
                        <p>{{MeteoObj.Arr.TafText}}</p>
                    <hr>
                </div>
                <div v-if="MeteoObj.DEP_alt.AirportICAO != ''">
                        <p>Dep Alt : {{MeteoObj.DEP_alt.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.DEP_alt.MetarText}}</p><br/>
                        <p>{{MeteoObj.DEP_alt.TafText}}</p>
                    <hr>
                </div>
                <div v-if="MeteoObj.ARR_alt1.AirportICAO != ''">
                        <p>Arr Alt1 : {{MeteoObj.ARR_alt1.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.ARR_alt1.MetarText}}</p><br/>
                        <p>{{MeteoObj.ARR_alt1.TafText}}</p>
                    <hr>
                </div>
                <div v-if="MeteoObj.ARR_alt2.AirportICAO != ''">
                        <p>Arr Alt2 : {{MeteoObj.ARR_alt2.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.ARR_alt2.MetarText}}</p><br/>
                        <p>{{MeteoObj.ARR_alt2.TafText}}</p>
                    <hr>
                </div>

                    <div v-if="MeteoObj.Enroute.AirportICAO != '' ">
                        <p>Enroute : {{MeteoObj.Enroute.AirportICAO}}</p><br/>
                        <p>{{MeteoObj.Enroute.MetarText}}</p><br/>
                        <p>{{MeteoObj.Enroute.TafText}}</p>
                        <hr>
                    </div>

            </div>
        </div>

        <div class="content" :class="{hide : !RaimShow}">
            <div v-html="WebText"></div>
        </div>

    </div>
</template>

<script>

    import {loadingMixin} from "../../../../utils/mixins";
    import {mapState, mapActions,mapGetters} from "vuex";

    import {createUrl} from "../../../../http"
    export default {
        name: "additionaldocuments",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        data() {
            return {
                activeUrl : createUrl('/EffIpadPreview/GetAttachment/'), //"https://localhost:44333/api/EffIpadPreview/GetAttachment/", //"createUrl('/EffIpadPreview/GetAttachment/')",     // bu kısmı state olarak al    //  "https://localhost:44333/api/EffIpadPreview/GetAttachment/"

                attachmentid : 0,
                GetAttachmentUrl :"",
                selectedDocument :"",
                selectedDocumentId : 0,

                // documentList : [
                //     {name: "WX", Id: 0},
                //     {name: "COVID-19 BORDER", Id: 0},
                //     {name: "Announcement", Id: 0},
                //     {name: "CAFIF", Id: 0},
                //     {name: "FIR NOTAM", Id: 0},
                //     {name: "NOTAM", Id: 0},
                //     {name: "UK PERMIT", Id: 0},
                //     {name: "200608 Corendon Measures", Id: 0},
                //     {name: "CAI5102 RAIM", Id: 0},
                //     {name: "ENROUTE", Id: 0},
                // ],

                AttachmentsByFKey : [],
                TableDataByFkey : [{FKey1:"",TableCode:"",Value:""}],
                getPdfStreamUrl : "",
                NotamPdfButtonTitle : "Notam",
                WeatherWebButtonTitle : "Weather",
                NotamWebButtonTitle : "Enroute Notam",
                RaimPredictionButtonTitle : "Raim Prediction",
                MeteoButtonTitle : "Meteo",
                FIRNotamButtonTitle : "FIR Notam",
                NotamWebText : "",
                WeatherWebText : "",
                WebText : "",
                Datashow : false,
                Pdfshow : false,
                RaimShow : false,
                Weatherwebshow : false,
                Meteoshow : false,
                NotamShow : false,
                FIRNotamShow : false,
                RaimPredictionData : "",
                MeteoObj : "",
                NotamObj : "",
                FIRNotamObj : "",
                WeatherWebObj : "",
                NotamWebObj : ""
            }
        },
       async created() {

                this.FillAttachmentstoDatagetters;

            },

       computed: {

            ...mapState("ipadmain",["selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","NotamImportantList"]),
            ...mapState("additionaldocuments", ["AttachmentFiles"]),
            ...mapGetters("additionaldocuments",["FillAttachmentstoDatagetters"]),

       },

       methods: {

            ...mapActions("additionaldocuments", ["getJsonDataNotamWeather","GetAttachmentsByFlight"]),

            getValueWithImportantWord(value)
            {
                var i;
                for (i = 0; i < this.NotamImportantList.length; i++) {
                    this.NotamImportantList[i]
                    value=value.replaceAll(this.NotamImportantList[i].word.toString().toUpperCase(),"<span style='color: "+this.NotamImportantList[i].color+";font-weight: '"+this.NotamImportantList[i].style+"'>"+this.NotamImportantList[i].word.toString().toUpperCase()+"</span>");
                }

                return value;
            },

            GetResultOfNotamPdf(value)
            {
                this.FIRNotamShow =false;
                this.Datashow = false;
                this.Pdfshow = false;
                this.RaimShow = false;
                this.NotamShow = true;
                this.Meteoshow = false;
                this.Weatherwebshow = false;
                this.selectedDocumentId = value;
                this.NotamObj = this.EFF_Json_Data.poNotam.NotamList;

            },

            GetResultOfMeteo(value)
            {
                this.FIRNotamShow =false;
                this.Datashow = false;
                this.Pdfshow = false;
                this.RaimShow = false;
                this.NotamShow = false;
                this.Meteoshow = true;
                this.Weatherwebshow = false;
                this.selectedDocumentId = value;
                this.MeteoObj = this.EFF_Json_Data.poMeteo;

            },

            GetResultOfOutput(KFZ,STD,id,alvt,attachmentTypeId)
            {

                // attachment.id,attachment.alvt,attachment.attachmentTypeId
                this.FIRNotamShow =false;
                this.Datashow =false;
                this.Pdfshow = true;
                this.RaimShow = false;
                this.NotamShow = false;
                this.Meteoshow = false;
                this.Weatherwebshow = false;
                this.getPdfStreamUrl = this.activeUrl + KFZ + "/" + STD + "/" + id + "/" + alvt + "/" + attachmentTypeId+"/"+this.flight.flightArchiveStat;

            },

            GetResultOfWeatherWeb(value)
            {
                this.FIRNotamShow =false;
                this.Datashow = false;
                this.Weatherwebshow = true;
                this.Pdfshow  = false;
                this.NotamShow = false;
                this.RaimShow = false;
                this.Meteoshow = false;
                this.selectedDocumentId = value;
                this.WeatherWebObj  = this.WR_Json_Data.LIST_USED_AIRPORTS;
            },

            GetResultOfNotamWeb(value)
            {
                this.FIRNotamShow =false;
                this.Datashow = true;
                this.Pdfshow  = false;
                this.RaimShow = false;
                this.NotamShow = false;
                this.Meteoshow = false;
                this.Weatherwebshow = false;
                this.selectedDocumentId = value;
                this.NotamWebObj  = this.WR_Json_Data.LIST_USED_AIRPORTS;

            },


            GetResultOfFIRNotam(value)
            {

                this.FIRNotamShow = true;
                this.Datashow = false;
                this.Pdfshow  = false;
                this.RaimShow = false;
                this.NotamShow = false;
                this.Meteoshow = false;
                this.Weatherwebshow = false;
                this.selectedDocumentId = value;
                //this.NotamWebObj  = this.WR_Json_Data.LIST_USED_AIRPORTS;
                this.FIRNotamObj = this.WR_Json_Data.NotamFIRWebText;

            },

            GetResultOfRaimPredictionRawHtml(value)
            {
                this.FIRNotamShow =false;
                this.Datashow = false;
                this.Pdfshow = false;
                this.RaimShow = true;
                this.NotamShow = false;
                this.Meteoshow = false;
                this.Weatherwebshow = false;
                this.selectedDocumentId = value;
                this.WebText  = this.WR_Json_Data.RaimPredictionHTMLText;

            }

        }
    }
</script>

<style scoped>
    .document-button {
        margin: 0;
        height: 80px;
        display: block;
        position: relative;
        width: 80px;
        font-size: 10px;
        font-weight: bold;
        font-family: sans-serif;
        transition: all .3s ease-in-out;
        white-space: break-spaces;

    }
    .hide {
        display:none;
    }


    br{
        content: " ";
    }
    .document-button:hover {
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
    }

    .notification {
        height: 80px;
        padding: 0;
    }

    .content {
        margin-top: 130px;
        height: 800px;
    }
</style>
